<div id="longtabs">
  <dx-tabs 
  [dataSource]="activetabs"
  (onItemClick)="selectTab($event)"
  [scrollByContent]="true"
  [selectedIndex]="selectedIndex"
  [showNavButtons]="true"
  [rtlEnabled]="currentLang=='ar'?true:false"
  ></dx-tabs>
</div>

 
